var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBendDownRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3538 9.85375L11.3538 12.8538C11.2599 12.9476 11.1327 13.0003 11 13.0003C10.8673 13.0003 10.7401 12.9476 10.6462 12.8538C10.5524 12.7599 10.4997 12.6327 10.4997 12.5C10.4997 12.3673 10.5524 12.2401 10.6462 12.1462L12.7931 10H8C6.27665 9.99818 4.62441 9.31278 3.40582 8.09418C2.18722 6.87559 1.50182 5.22335 1.5 3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3C2.13261 3 2.25979 3.05268 2.35355 3.14645C2.44732 3.24021 2.5 3.36739 2.5 3.5C2.50165 4.95818 3.08165 6.35617 4.11274 7.38726C5.14383 8.41835 6.54182 8.99835 8 9H12.7931L10.6462 6.85375C10.5524 6.75993 10.4997 6.63268 10.4997 6.5C10.4997 6.36732 10.5524 6.24007 10.6462 6.14625C10.7401 6.05243 10.8673 5.99972 11 5.99972C11.1327 5.99972 11.2599 6.05243 11.3538 6.14625L14.3538 9.14625C14.4002 9.19269 14.4371 9.24783 14.4623 9.30853C14.4874 9.36923 14.5004 9.43429 14.5004 9.5C14.5004 9.56571 14.4874 9.63077 14.4623 9.69147C14.4371 9.75217 14.4002 9.80731 14.3538 9.85375Z",
    fill: "#F0EAD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBendDownRight);
export default __webpack_public_path__ + "static/media/ArrowBendDownRight.3391a28fb9604e0d5efa1896355c467d.svg";
export { ForwardRef as ReactComponent };